export const CART_LOADING = "cart/loading";
export const CART_ERROR = "cart/error";

export const GET_CART = "cart/get";
export const ADD_CART = "cart/add";
export const UPDATE_CART = "cart/update";
export const DELETE_FROM_CART = "cart/delete";
export const EMPTY_CART = "cart/empty";